// Vendor libraries
import { ElementRef } from '@angular/core';
// Constants / utils
import { PASSKEY_BROWSER_UUID_ID_KEY } from 'PasskeysApp/constants';
import { localStorageAvailable } from 'NewAngular/utils/local-storage-utils';
// Services
import { PasskeysService } from 'PasskeysApp/services/passkeys.service';
import * as i0 from "@angular/core";
import * as i1 from "PasskeysApp/services/passkeys.service";
export class PasskeyLoginComponent {
    constructor(el, passkeysService) {
        this.el = el;
        this.passkeysService = passkeysService;
    }
    ngOnInit() {
        if (localStorageAvailable() && localStorage.getItem(PASSKEY_BROWSER_UUID_ID_KEY)) {
            this.login();
        }
        else {
            this.el.nativeElement.style.display = 'none';
        }
    }
    login() {
        this.passkeysService.authenticatePasskey().subscribe({
            next: (response) => {
                // URL comes in the response only when the login is successful, and it was already validated by the backend.
                window.location.href = response.url;
            },
            error: (error) => {
                if (error.name === 'NotAllowedError') {
                    // User cancelled the login prompt.
                    return;
                }
                const errorMessageContainer = document.getElementById('login-error-container');
                if (error.status === 403) {
                    errorMessageContainer.innerHTML =
                        '<div class="feedback feedback-invalid"><p class="msg">Invalid Passkey.</p></div>';
                }
                else {
                    errorMessageContainer.innerHTML =
                        '<div class="feedback feedback-invalid"><p class="msg">Server is unable to process the provided key.</p></div>';
                }
            },
        });
    }
}
PasskeyLoginComponent.ɵfac = function PasskeyLoginComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PasskeyLoginComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.PasskeysService)); };
PasskeyLoginComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PasskeyLoginComponent, selectors: [["ycn-passkey-login"]], standalone: false, decls: 3, vars: 0, consts: [[1, "form-link", "pb-4px"], ["href", "javascript:void(0)", 3, "click"]], template: function PasskeyLoginComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
        i0.ɵɵlistener("click", function PasskeyLoginComponent_Template_a_click_1_listener() { return ctx.login(); });
        i0.ɵɵtext(2, "Log in with Passkey");
        i0.ɵɵelementEnd()();
    } }, encapsulation: 2 });
